module.exports = __webpack_public_path__ + "img/Methodical Organiser.dee8c7ec.svg";